import { postV2ApiAuthenticationFactors } from 'src/client/spendesk-api';
import { type PostV2ApiAuthenticationFactorsResponseCreated } from 'src/client/spendesk-api-types';
import { logger } from 'src/utils/datadog-log-wrapper';

export const postUserAuthenticationFactor = async ({
  name,
}: {
  name: string;
}): Promise<PostV2ApiAuthenticationFactorsResponseCreated['data']> => {
  logger.debug(`Requesting user authentication factors creation`, {
    scope: 'user-authentication-factors',
    team: 'cards-ux',
  });
  const response = await postV2ApiAuthenticationFactors({
    body: {
      name,
      type: 'TOTP',
    },
  });

  if (response.statusCode !== 201) {
    logger.error('Failed to create user authentication factor.', {
      error: response.body,
      scope: 'user-authentication-factors',
      team: 'cards-ux',
    });
    throw new Error('Failed to create user authentication factor.');
  }

  return response.body.data;
};
